var moment = require('moment'),
    withTimezone = require('./vendor');

module.exports = withTimezone(moment);